import { createMaterialTopTabNavigator } from "@react-navigation/material-top-tabs";
import React, { useContext } from "react";
import { View } from "../../../components/shared/Themed";

import Colors from "../../../utils/constants/colors";
import useColorScheme from "../../../hooks/useColorScheme";
import { useAppTheme } from "../../../hooks/useAppTheme";
import ContentTitleHeader from "../../../components/core/ContentTitleHeader";
import TabBarIcon from "../../../components/core/TabBarIcon";
import { RootTabParamList, RootTabScreenProps } from "../../../types";
import DeviceOrientationContext from "../../../components/context/DeviceOrientationContext";
import HubspotSettingCompanyScreen from "../../../screens/Settings/HubspotSettingScreens/HubspotSettingCompanyScreen";
import CreateCompanyForm from "../../../screens/Settings/HubspotSettingScreens/CreateCompanyForm";
import { useTranslation } from "../../../utils/useTranslation";

const Tab = createMaterialTopTabNavigator<RootTabParamList>();

export default function HubspotSettingsTabNavigator({ navigation }: any) {
  const { t } = useTranslation();
  const colorScheme = useColorScheme();
  const orientationContext = useContext(DeviceOrientationContext);
  return (
    <View
      style={{
        height: "100%",
        backgroundColor: colorScheme === "light" ? "#fafafa" : "#1F2937",
      }}
    >
      {!orientationContext.isSmallDevice && (
        <ContentTitleHeader name="Hubspot Settings" navigation={navigation} />
      )}
      <Tab.Navigator
        initialRouteName="Company"
        screenOptions={{
          tabBarActiveTintColor: Colors[colorScheme].tint,
          tabBarStyle: {
            height: 50,
            width: orientationContext.isSmallDevice ? "100%" : "50%",
            alignSelf: orientationContext.isSmallDevice
              ? "flex-start"
              : "center",
            justifySelf: orientationContext.isSmallDevice
              ? "flex-start"
              : "center",
            borderTopWidth: 0,
            backgroundColor: colorScheme === "light" ? "#fafafa" : "#1F2937",
          },
          tabBarLabelStyle: {
            fontSize: 14,
            fontWeight: "bold",
            textTransform: "none",
          },
          tabBarItemStyle: {
            width: "auto", // Automatically adjusts tab width based on content
            paddingHorizontal: 10, // Adjust padding to avoid text wrapping
            flex: 1, // Allow flexibility for tabs with longer names
          },
        }}
      >
        {process.env.NODE_ENV !== "production" && (
          <Tab.Screen
            name="Company"
            component={HubspotSettingCompanyScreen}
            options={({ navigation }: RootTabScreenProps<"Company">) =>
              orientationContext.isSmallDevice
                ? {
                    title: "",
                    tabBarIcon: ({ color }) =>
                      orientationContext.isSmallDevice && (
                        <TabBarIcon name="user-circle" color={color} />
                      ),
                  }
                : {
                    title: t("company"),
                  }
            }
          />
        )}

        <Tab.Screen
          name="CreateCompany"
          component={CreateCompanyForm}
          options={({ navigation }: RootTabScreenProps<"CreateCompany">) =>
            orientationContext.isSmallDevice
              ? {
                  title: "",
                  tabBarIcon: ({ color }) =>
                    orientationContext.isSmallDevice && (
                      <TabBarIcon name="key" color={color} />
                    ),
                }
              : {
                  title: t("createCompany"),
                }
          }
        />
      </Tab.Navigator>
    </View>
  );
}
